import { render } from "./UserNotificationsShow.vue?vue&type=template&id=a0aa024c"
import script from "./UserNotificationsShow.vue?vue&type=script&lang=js"
export * from "./UserNotificationsShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__